module.exports = __webpack_public_path__ + "static/img/19.eb48425.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/zh/19.png
// module id = GBqa
// module chunks = 0